/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { Logger } from "cms/utils/log/logger";

const usePartnerCityViz = () => {
    
    const fetchCityVizWidgets = async (token) => {
        let widgets;
        try {
            widgets = await SimpliCityAdminSDK.partner.cityviz.getWidgetList(token);
            if (!widgets) {
                throw Error("Failed to return Component Categories.");
            }
            return widgets;
        } catch (error) {
            Logger.error(error);
            return { error, widgets };
        }
    };
    
    return {
        fetchCityVizWidgets,
    };
};

export { usePartnerCityViz };
